// The reader's preferred script for names, ingredients and steps; remembered on this device.
import { useEffect, useState } from 'preact/hooks';
import { load, save, KEYS } from './storage';
import type { Script } from './types';

const listeners = new Set<(s: Script) => void>();

export function getScript(): Script {
  const s = load<Script>(KEYS.script, 'ta');
  return s === 'en' || s === 'tg' ? s : 'ta';
}

export function setScript(s: Script) {
  save(KEYS.script, s);
  listeners.forEach((l) => l(s));
}

export function useScript(): [Script, (s: Script) => void] {
  const [s, set] = useState<Script>(getScript);
  useEffect(() => {
    listeners.add(set);
    return () => void listeners.delete(set);
  }, []);
  return [s, setScript];
}

